/**
 * IXD vs Workbook 구조 비교 페이지 스토어 Provider
 */

import { useRef } from "react";
import {
  createIxdWorkbookCompareStore,
  IxdWorkbookCompareStoreContext,
} from "@/stores/ixd-workbook-compare";

export const IxdWorkbookCompareStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const storeRef = useRef<ReturnType<
    typeof createIxdWorkbookCompareStore
  > | null>(null);
  if (!storeRef.current) {
    storeRef.current = createIxdWorkbookCompareStore();
  }

  return (
    <IxdWorkbookCompareStoreContext.Provider value={storeRef.current}>
      {children}
    </IxdWorkbookCompareStoreContext.Provider>
  );
};
